import { PaymentBankProps } from "../../../types/types";
import { Box, Text, Image } from '@mantine/core';

export function PaymentBank(props:PaymentBankProps){
    return (
        <Box sx={() => ({
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "10px",
            
            
        })}>
            <Box sx={() => ({
                marginLeft: "0px",
                marginBottom: "0px"
            })}>
                <Image width={35} height={35} src={props.image} />
            </Box>
                
            
        <Text weight={500} size="sm">
            {props.bankName}
        </Text>
        </Box>
    )
}